<mat-form-field [class]="inputClass">

  <mat-label>{{label}}</mat-label>

  <input #searchInput
    matInput
    [errorStateMatcher]="errorStateMatcher"
    [matAutocomplete]="auto"
    [placeholder]="placeholder"
    [(ngModel)]="value"
    type="text"
    (input)="onInput($event.target.value)"
    (blur)="onTouched()">

    <mat-autocomplete #auto="matAutocomplete"
      (optionSelected)="onSelect($event.option.value)"
      [displayWith]="displayFn">

      @if (filteredOptions.length) {
        <!-- Group mode -->
        @if (groupBy) {
          @for (groupName of groupedOptions.keys; track groupName) {
            <mat-optgroup [label]="groupName">
              @for (option of groupedOptions.get(groupName); track option) {
                <mat-option [value]="option">
                  {{option.name}}
                </mat-option>
              }
            </mat-optgroup>
          }
        }
        <!-- List mode -->
        @if (!groupBy) {
          @for (option of filteredOptions; track option) {
            <mat-option [value]="option">
              {{option.name}}
            </mat-option>
          }
        }
      }

    </mat-autocomplete>

    <div matSuffix>
      <ng-container [appPreloader]="[endpoints.COUNTRIES_GET]"
        [preloaderType]="preloaderTypes.ICON"
        [preloaderSize]="20">
      </ng-container>
    </div>

    <!-- Show control errors -->
    <mat-error>
      <app-validation-error [errors]="ngControl.errors"></app-validation-error>
    </mat-error>
  </mat-form-field>
